module.exports = __webpack_public_path__ + "media/images/cv/screenshot_ask-5e6398dce7d6ac2c41bdfcce6f10df6e.jpg";